import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"

class VerAlunoAdmin extends Component {


  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-sm-8 p-4">     

        <h4>Ver Aluno #</h4>     
        <form>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome</label>
                    <input type="email" class="form-control" id="exampleFormControlInput1" readOnly />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">E-mail</label>
                    <input type="email" class="form-control" id="exampleFormControlInput1" placeholder="Novo Nome" readOnly/>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Telefone</label>
                    <input type="email" class="form-control" id="exampleFormControlInput1" placeholder="Novo Nome" readOnly />
                </div>

        </form>



<br></br>
<h3>Matriculas</h3>


 {/* Tables */}

    <table id="dtBasicExample" class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
  <thead>
    <tr>
      <th class="th-sm">Nome Curso

      </th>
      <th class="th-sm">Categoria

      </th>
      <th class="th-sm">Duração Semestre

      </th>
      <th class="th-sm">Data Inscrição

      </th>
      <th class="th-sm">Inscrição

      </th>

      <th class="th-sm">Mensalidade

      </th>
      <th class="th-sm">Status

      </th>
      <th class="th-sm">Ação

      </th>


    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Tiger Nixon</td>
      <td>System Architect</td>
      <td>Tiger Nixon</td>
      <td>Tiger Nixon</td>
      <td>System Architect</td>
      <td>Tiger Nixon</td>
      <td>System Architect</td>
      <td>
          <button class="btn btn-secondary btn-sm">Editar</button>
          <button class="btn btn-danger btn-sm">Remover</button>
      </td>
    </tr>

    <tr>
      <td>Tiger Nixon</td>
      <td>System Architect</td>
      <td>Tiger Nixon</td>
      <td>System Architect</td>
      <td>Tiger Nixon</td>
      <td>Tiger Nixon</td>
      <td>System Architect</td>
      <td>
          <button class="btn btn-secondary btn-sm">Editar</button>
          <button class="btn btn-danger btn-sm">Remover</button>
      </td>
    </tr>
    
  </tbody>

</table>

{/* FIm table */}












    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(VerAlunoAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/veralunos.js